// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"174":"39e134ea","1313":"444ec640","1506":"358362c0","2924":"ccf279b5","5280":"31d6cfe0","6507":"b30baa3c","7518":"31d6cfe0"}[chunkId] + ".chunk.css";
};